import {DASHBOARD_MESSAGING_ACTIONS} from "../../misc/constants";
import store from "../../store";
import {changeAllCartItems} from "../../actions/shoppingCartFunctions";
import {getSaveQuoteFastData} from "../../api/server-api";
import {toggleUseFabricatorCostPrices} from "../../actions/actionFunctions";
import {IS_DASHBOARD_MESSAGING} from "../../config";
import {getCurrentReceipt, setReceiptReferral} from "../../actions/printFunctions";

const sendJobDataToParent = async (withReceipt = false) => {
  // 2) get new total
  // const {jobId} = store.getState().serverState;
  // console.log("!!sendJobDataToParent", document.kvConfig.jobId, jobId);

  const savedFastData = await getSaveQuoteFastData(true);
  const payload = {
    jobId: document.kvConfig.jobId,
    jobData: savedFastData,
  }
  if (withReceipt) {
    const receipt = await getCurrentReceipt();
    const receiptBlob = await receipt.toBlob();
    // const receiptUrl = URL.createObjectURL(blobReceipt); // on a dashboard end
    // console.log("receipt", receipt);
    payload.receiptBlob = receiptBlob;
  }
  // 3) sent parent what they want
  window.parent.postMessage({
    action: DASHBOARD_MESSAGING_ACTIONS.jobDataAfterUpdate,
    payload
  }, "*");
  return Promise.resolve()
}

export const listenToDashboardMessaging = async () => {
  if (!IS_DASHBOARD_MESSAGING) {
    return
  }

  window.addEventListener("message",  (event) => {
    if (!event || !event.data || !event.data.action) {
      return
    }
    switch (event.data.action) {
      case DASHBOARD_MESSAGING_ACTIONS.updateCartItems: {
        // console.log("DASHBOARD_MESSAGING_ACTIONS.updateCartItems event", event.data);
        if (!event.data.payload || !event.data.payload.cartItems) {
          console.error("incorrect action");
        }
        const {cartItems} = store.getState().cartState;
        // 1) update store with passed cart items
        store.dispatch(changeAllCartItems(cartItems.map(cartItem => {
          const payloadCartItem = event.data.payload.cartItems.find(payloadCI => payloadCI.id === cartItem.id);
          if (payloadCartItem) {
            return {...cartItem, isRemoved: payloadCartItem.isRemoved};
          }
          return cartItem
        })));
        sendJobDataToParent();
        break;
      }
      case DASHBOARD_MESSAGING_ACTIONS.setCostPrices: {
        store.dispatch(toggleUseFabricatorCostPrices(event.data.payload));
        sendJobDataToParent();
        break;
      }
      case DASHBOARD_MESSAGING_ACTIONS.setReferralData: {
        store.dispatch(setReceiptReferral(event.data.payload));
        sendJobDataToParent(true);
        break;
      }
      default:
        break;
    }
  });

  sendJobDataToParent(); // send the first time
}
